const profiles = [
    {
        id: '1',
        image: 'https://images.unsplash.com/photo-1552058544-f2b08422138a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&q=80&w=400',
        username: 'jackson-todd',
        position: 'left-[10%] top-[20%]'
    },
    {
        id: '2',
        image: 'https://images.unsplash.com/photo-1500048993953-d23a436266cf?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&q=80&w=400',
        username: 'lillian-smith',
        position: 'left-[30%] top-[10%]'
    },
    {
        id: '3',
        image: 'https://images.unsplash.com/photo-1563237023-b1e970526dcb?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&q=80&w=400',
        username: 'anthony-de',
        position: 'right-[30%] top-[20%]'
    },
    {
        id: '4',
        image: 'https://media.istockphoto.com/id/866198538/photo/glasses-guy.jpg?s=612x612&w=0&k=20&c=LZW-D7fm5we-lq0YHHVYbhNoPHjQ20rkP110FQKwU9k=',
        username: 'wendy-green',
        position: 'right-[10%] top-[40%]'
    },
    {
        id: '5',
        image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&q=80&w=400',
        username: 'sam-miles',
        position: 'left-[20%] bottom-[20%]'
    },
    {
        id: '6',
        image: 'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&q=80&w=400',
        username: 'sarah-parker',
        position: 'right-[20%] bottom-[20%]'
    }
]

export default function CommunitySection() {
    return (
        <section className="min-h-screen relative flex flex-col items-center justify-center px-4 py-20 bg-gradient-to-b from-gray-800 to-gray-900 overflow-hidden">
            {/* Profile Images */}
            {profiles.map((profile) => (
                <div
                    key={profile.id}
                    className={`absolute ${profile.position} transition-all duration-500 hover:scale-105`}
                >
                    <div className="relative group">
                        <img
                            src={profile.image}
                            alt={`${profile.username}'s profile`}
                            className="w-24 h-24 sm:w-32 sm:h-32 object-cover rounded-lg"
                        />
                    </div>
                </div>
            ))}

            {/* Central Text */}
            <div className="z-10 text-center text-white">
                <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-4">
                    Join our community.
                </h2>
                <p className="text-3xl sm:text-4xl md:text-5xl text-gray-400">
                    Make it yours.
                </p>
            </div>
        </section>
    )
}